(function() {
    'use strict';

a3_cabin_reports.directive('aircraftDifferences',aircraftDifferences);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name aircraftDifferences
   * @restrict E
   * @description
   *   Implementation of aircraft differences
   *
   *   Display the differences of Aircrafts
   * @attr {String} registration The registration of the aircraft.
   * @example
   *   Usage:
   *   <aircraft-differences registration="sxreg"></aircraft-differences>
   * @ngInject
   */    
function aircraftDifferences(AircraftDifferencesFactory) {
    function link(scope, element, attributes){
    
        var AircraftDifferencesObj = AircraftDifferencesFactory.getAircraftDifferenceFromStorageByRegistration(attributes.registration); 
        scope.AircraftDifferences =  AircraftDifferencesObj != null && AircraftDifferencesObj.AircraftDifferences  != null ? AircraftDifferencesObj.AircraftDifferences : []; 

        
    }
    
    
    return {
			restrict: 'E',
			terminal: true,
			templateUrl: 'views/directives/aircraftDifferences.tpl.html',
			scope: false,
            link: link
		}
}
    })();